"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomBannerWrapper = exports.Container = void 0;
const stitches_config_1 = require("../../../stitches.config");
exports.Container = (0, stitches_config_1.styled)("div", {
    envRelativeHeight: "100vh",
    width: "100%",
    position: "relative",
});
exports.BottomBannerWrapper = (0, stitches_config_1.styled)("div", {
    position: "fixed",
    zIndex: 13,
    width: "100%",
    bottom: "16px",
    padding: "0 8px",
    "@lg": {
        width: "400px",
        left: "39%",
        bottom: "24px",
        padding: 0,
    },
    variants: {
        infoPanelOpen: {
            true: {
                "@lg": {
                    left: "52%",
                },
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRnVsbFBhZ2VNYXAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9jb21wb25lbnRzL01hcHMvX19zdHlsZXNfXy9GdWxsUGFnZU1hcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw4REFBa0Q7QUFFckMsUUFBQSxTQUFTLEdBQUcsSUFBQSx3QkFBTSxFQUFDLEtBQUssRUFBRTtJQUNyQyxpQkFBaUIsRUFBRSxPQUFPO0lBQzFCLEtBQUssRUFBRSxNQUFNO0lBQ2IsUUFBUSxFQUFFLFVBQVU7Q0FDckIsQ0FBQyxDQUFDO0FBRVUsUUFBQSxtQkFBbUIsR0FBRyxJQUFBLHdCQUFNLEVBQUMsS0FBSyxFQUFFO0lBQy9DLFFBQVEsRUFBRSxPQUFPO0lBQ2pCLE1BQU0sRUFBRSxFQUFFO0lBQ1YsS0FBSyxFQUFFLE1BQU07SUFDYixNQUFNLEVBQUUsTUFBTTtJQUNkLE9BQU8sRUFBRSxPQUFPO0lBQ2hCLEtBQUssRUFBRTtRQUNMLEtBQUssRUFBRSxPQUFPO1FBQ2QsSUFBSSxFQUFFLEtBQUs7UUFDWCxNQUFNLEVBQUUsTUFBTTtRQUNkLE9BQU8sRUFBRSxDQUFDO0tBQ1g7SUFDRCxRQUFRLEVBQUU7UUFDUixhQUFhLEVBQUU7WUFDYixJQUFJLEVBQUU7Z0JBQ0osS0FBSyxFQUFFO29CQUNMLElBQUksRUFBRSxLQUFLO2lCQUNaO2FBQ0Y7U0FDRjtLQUNGO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgc3R5bGVkIH0gZnJvbSBcIi4uLy4uLy4uL3N0aXRjaGVzLmNvbmZpZ1wiO1xuXG5leHBvcnQgY29uc3QgQ29udGFpbmVyID0gc3R5bGVkKFwiZGl2XCIsIHtcbiAgZW52UmVsYXRpdmVIZWlnaHQ6IFwiMTAwdmhcIixcbiAgd2lkdGg6IFwiMTAwJVwiLFxuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxufSk7XG5cbmV4cG9ydCBjb25zdCBCb3R0b21CYW5uZXJXcmFwcGVyID0gc3R5bGVkKFwiZGl2XCIsIHtcbiAgcG9zaXRpb246IFwiZml4ZWRcIixcbiAgekluZGV4OiAxMyxcbiAgd2lkdGg6IFwiMTAwJVwiLFxuICBib3R0b206IFwiMTZweFwiLFxuICBwYWRkaW5nOiBcIjAgOHB4XCIsXG4gIFwiQGxnXCI6IHtcbiAgICB3aWR0aDogXCI0MDBweFwiLFxuICAgIGxlZnQ6IFwiMzklXCIsXG4gICAgYm90dG9tOiBcIjI0cHhcIixcbiAgICBwYWRkaW5nOiAwLFxuICB9LFxuICB2YXJpYW50czoge1xuICAgIGluZm9QYW5lbE9wZW46IHtcbiAgICAgIHRydWU6IHtcbiAgICAgICAgXCJAbGdcIjoge1xuICAgICAgICAgIGxlZnQ6IFwiNTIlXCIsXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgIH0sXG4gIH0sXG59KTtcbiJdfQ==